const { jQuery: $ } = window;

require("select2");